import React from 'react';
import { Box, Typography, Container, Paper } from '@mui/material';

export default function About() {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h3" gutterBottom>
          About SVC Uptime
        </Typography>
        <Typography variant="body1" paragraph>
          SVC Uptime is a comprehensive service monitoring solution that helps you track
          the availability and performance of your services in real-time.
        </Typography>
        <Typography variant="h5" gutterBottom sx={{ mt: 3 }}>
          Features
        </Typography>
        <Typography variant="body1" component="ul">
          <li>Real-time service monitoring</li>
          <li>Historical uptime statistics</li>
          <li>Customizable alerts and notifications</li>
          <li>Detailed analytics and reporting</li>
        </Typography>
      </Paper>
    </Container>
  );
}

